import React from 'react';
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from 'recharts';
import StatisticsGlassCard from './StatisticsGlassCard';
import StatisticsDesktopSectionHeader from './StatisticsDesktopSectionHeader';
import { STATS_ICONS } from './statisticsAssets';
import useChartContainerReady from './useChartContainerReady';

export default function StatisticsDesktopVisitTypesCard({
  isEditMode,
  longPressHandlers,
  visitTypeStats,
}) {
  const { containerRef, isReady } = useChartContainerReady();
  const totalCount = visitTypeStats.reduce((acc, d) => acc + d.value, 0);

  return (
    <StatisticsGlassCard className="h-full p-6 flex flex-col" {...longPressHandlers} isEditMode={isEditMode}>
      <StatisticsDesktopSectionHeader
        iconSrc={STATS_ICONS.memo}
        title="심방 유형"
        badge={`${totalCount}건`}
      />

      <div ref={containerRef} className="flex-1 min-h-[160px] min-w-0">
        {visitTypeStats.length > 0 ? (
          isReady ? (
            <ResponsiveContainer width="100%" height="100%" minWidth={0} minHeight={160}>
              <BarChart data={visitTypeStats} layout="vertical" margin={{ top: 5, right: 20, left: 10, bottom: 5 }}>
                <CartesianGrid strokeDasharray="3 3" horizontal={false} stroke="#F3F4F6" />
                <XAxis type="number" hide />
                <YAxis
                  type="category"
                  dataKey="name"
                  axisLine={false}
                  tickLine={false}
                  tick={{ fontSize: 11, fontWeight: 700, fill: '#6B7280' }}
                  width={40}
                />
                <Tooltip
                  cursor={{ fill: 'rgba(0,0,0,0.03)' }}
                  contentStyle={{
                    backgroundColor: 'rgba(255,255,255,0.98)',
                    border: 'none',
                    borderRadius: '16px',
                    boxShadow: '0 12px 48px rgba(0,0,0,0.12)',
                    padding: '10px 14px',
                    fontSize: '12px',
                    fontWeight: 700,
                  }}
                  formatter={(value) => [`${value}회`, '심방']}
                />
                <Bar dataKey="value" radius={[0, 8, 8, 0]} barSize={20} animationDuration={1200}>
                  {visitTypeStats.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color} fillOpacity={0.85} />
                  ))}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          ) : null
        ) : (
          <div className="w-full h-full flex items-center justify-center text-gray-300 font-bold">
            <div className="text-center">
              <div className="text-3xl mb-2">📝</div>
              <p className="text-sm">심방 기록이 없습니다</p>
            </div>
          </div>
        )}
      </div>
    </StatisticsGlassCard>
  );
}
